<template>
  <Tippy
    ref="popover"
    trigger="manual"
    interactive
    theme="light"
    :hide-on-click="false"
  >
    <template #trigger>
      <div
        v-if="!edited"
        class="content"
      >
        <div class="title">
          <i
            v-if="updated ? updated.mealId : initial?.mealId"
            class="fa-regular fa-pot-food"
          />
          {{ updated ? updated.title : initial?.title }}
        </div>
        <div class="description">
          {{ updated ? updated.description : initial?.description }}
        </div>
        <div class="tags">
          {{ updated ? updated.tags?.join(',') : initial?.tags?.join(',') }}
        </div>
      </div>
    </template>

    <div>
      <Transition name="fade">
        <form
          class="cell-edit"
          @submit.stop.prevent="save"
        >
          <div class="textarea-wrapper">
            <label
              class="textarea-label"
              for="title-textarea"
            >{{ $t('general.title') }}</label>
            <textarea
              id="title-textarea"
              ref="title"
              v-model="title"
              class="day-textarea"
              @input="mealId = ''"
              @keydown.enter.prevent="selectFirstMeal"
            />
          </div>

          <div class="meals-wrapper">
            <div class="meals-list">
              <div
                v-for="meal in filteredMeals"
                :key="meal.id"
                class="meal-row"
                @click="selectMeal(meal)"
              >
                {{ meal.name }}
              </div>
            </div>
          </div>
          <!-- <div class="textarea-wrapper">
            <label
              class="textarea-label"
              for="description-textarea"
            >{{ $t('general.description') }}</label>
            <textarea
              id="description-textarea"
              v-model="description"
              class="day-textarea"
            />
          </div> -->
          <!-- <div class="textarea-wrapper">
            <label
              class="textarea-label"
              for="tags-input"
            >{{ $t('shop.tagsAlergens') }}</label>
            <input
              id="tags-input"
              v-model="tags"
              class="day-textarea"
            >
          </div> -->

          <div class="d-flex pt-2">
            <button
              class="btn btn-sm btn-secondary mr-1"
              type="button"
              :disabled="unchanged"
              @click.prevent.stop="revert"
            >
              <i class="far fa-rotate-left" />
            </button>
            <button
              class="btn btn-sm btn-block btn-primary"
              type="submit"
            >
              <i class="far fa-check" />
            </button>
          </div>
        </form>
      </Transition>
    </div>
  </Tippy>
</template>

<script>
export default {
  props: {
    dietId: String,
    productId: String,
    day: String,
    edited: Boolean,
    initial: Object,
    updated: Object,
    meals: Array,
  },
  data: () => ({
    title: '',
    mealId: '',
  }),
  computed: {
    unchanged() {
      if (!this.initial) {
        return this.title === ''
          && this.mealId === '';
      }

      return this.initial
        && this.initial.mealId === this.mealId
        && this.initial.title === this.title;
    },
    cell() {
      return {
        title: this.title,
        mealId: this.mealId,
      };
    },
    filteredMeals() {
      return this.meals.filter((meal) => meal.name.toLowerCase().includes(this.title.toLowerCase()));
    },
  },
  watch: {
    edited(v) {
      if (v) {
        this.$refs.popover.tippy().show();

        if (this.initial) {
          this.title = this.initial.title;
          this.mealId = this.initial.mealId;
        }

        if (this.updated) {
          this.title = this.updated.title;
          this.mealId = this.updated.mealId;
        }

        setTimeout(() => {
          if (this.$refs.title) {
            this.$refs.title.focus();
          }
        }, 0);
      } else {
        this.$refs.popover.tippy().hide();
      }
    },
    cell() {
      this.emit();
    },
  },
  methods: {
    selectMeal(meal) {
      this.title = meal.name;
      this.mealId = meal.id;
      this.emit();
      this.save();
    },
    selectFirstMeal() {
      if (this.filteredMeals.length > 0) {
        this.selectMeal(this.filteredMeals[0]);
      }
    },
    emit() {
      if (!this.initial
        && this.cell.title === ''
        && this.cell.mealId === '') {
        this.$emit('update:updated', null);
      }

      if (this.initial
        && this.cell.title === this.initial.title
        && this.cell.mealId === this.initial.mealId) {
        this.$emit('update:updated', null);
        return;
      }

      this.$emit('update:updated', {
        dietId: this.dietId,
        productId: this.productId,
        day: this.day,
        title: this.cell.title,
        mealId: this.cell.mealId === '' ? null : this.cell.mealId,
      });
    },
    revert() {
      if (this.initial) {
        this.title = this.initial.title;
        this.mealId = this.initial.mealId;
      } else {
        this.title = '';
        this.mealId = '';
      }

      this.emit();
      this.$emit('close');
    },
    save() {
      this.$refs.popover.tippy().hide();
      this.$emit('close');
    },
  },
  created() {

  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 5px;
  .title {
    font-weight: 500;
  }
}

.cell-edit {
  position: absolute;
  z-index: 10;
  background: white;
  box-shadow: 0 0 15px rgba(0,0,0,0.1);
  width: 250px;
  padding: 10px;
  top: -1px;
  left: -1px;
}

.meals-wrapper {
  height: 150px;
  overflow-y: auto;
}

.meal-row {
  text-align: left;
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
  background: #f6f6f6;
  margin-bottom: 2px;
  font-size: 12px;
  font-weight: 500;

  &:hover {
    background: #eee;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
  transform-origin: top left;
}

.fade-enter,
.fade-leave-to {
  transform: scale(0.25);
  opacity: 0;
}

.fade-enter-to,
.fade-leave {
  transform: scale(1);
  opacity: 1;
}

.textarea-wrapper {
  position: relative;
  margin-bottom: 8px;

  .textarea-label {
    position: absolute;
    top: -8px;
    left: 8px;
    padding: 0 4px;
    font-size: 12px;
    background: white;
    color: #666;
  }

  .day-textarea {
    padding-top: 8px;
  }
}

.day-textarea {
  border: 1px solid #eee;
  resize: none;
  width: 100%;
  padding: 8px;

  &:focus {
    outline: none;
    border-color: #666;
  }
}
</style>
